import {
  TOOLTIP_PLACEMENT_RIGHT,
  TOOLTIP_SIZE_MEDIUM,
  TOP_BAR_HEIGHT,
  type TooltipPlacement,
  type TooltipSize,
} from '@aibuild/ui';

/** Rail logos sit on the page title's centre line so the expand handle can share it. */
export const RAIL_LOGO_CENTER = TOP_BAR_HEIGHT / 2;

export const RAIL_TOOLTIP: {
  readonly placement: TooltipPlacement;
  readonly size: TooltipSize;
  readonly portal: true;
} = { placement: TOOLTIP_PLACEMENT_RIGHT, size: TOOLTIP_SIZE_MEDIUM, portal: true };
